// @flow
import { styled } from 'mz-ui-kit';

export const Container = styled('div', {
  display: 'flex',
  width: '100%',
  minHeight: '0px',
  flexDirection: 'column',
  justifyContent: 'start',
  alignItems: 'start',
  background: '#fff'
});
